export const sortByKey = (array: any[], key: string) => array?.slice().sort((a, b) => {
  const x = a[key]; const y = b[key]
  // eslint-disable-next-line no-nested-ternary
  return ((x < y) ? -1 : ((x > y) ? 1 : 0))
})
